import React from "react";
import Xarrow from "react-xarrows";
import { FormattedMessage } from "react-intl";

const style = {
	itemsWrapper: `flex items-center justify-center gap-8 text-[9px] whitespace-nowrap lg:text-base`,
	colFirst: `bg-blue px-3 py-1.5 flex items-center justify-center rounded-full min-w-[100px] lg:min-w-[200px] z-10`,
	stepWhite: `bg-white text-dark px-3 py-1.5 flex items-center justify-center rounded-full w-fit z-10`,
	stepRed: `bg-red text-white px-3 py-1.5 flex items-center justify-center rounded-full w-fit z-10`,
	stepLime: `bg-lime text-dark px-3 py-1.5 flex items-center justify-center rounded-full w-fit z-10`,
	list: `flex items-center`,
	colList: `flex gap-4 flex-col ml-8 lg:ml-24`,
};

const StepItems = () => {
	return (
		<div className={style.itemsWrapper}>
			<div className={style.colList}>
				<div className={style.list}>
					<div id='structureOne' className={style.colFirst}>
						<h4 className='aubrey-pro'>
							<FormattedMessage id='courseStructureOne' />
						</h4>
					</div>
					<div className={style.colList}>
						<div id='structureOne-first' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureOne-first' />
							</h4>
						</div>
						<div id='structureOne-second' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureOne-second' />
							</h4>
						</div>
						<div id='structureOne-third' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureOne-third' />
							</h4>
						</div>
						<div className={style.list}>
							<div id='structureOne-fourth' className={style.stepWhite}>
								<h4>
									<FormattedMessage id='courseStructureOne-fourth' />
								</h4>
							</div>
							<div className={style.colList}>
								<div id='structureOne-fourth-1' className={style.stepRed}>
									<h4>
										<FormattedMessage id='courseStructureOne-fourth-1' />
									</h4>
								</div>
								<div id='structureOne-fourth-2' className={style.stepLime}>
									<h4>
										<FormattedMessage id='courseStructureOne-fourth-2' />
									</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className={style.list}>
					<div id='structureTwo' className={style.colFirst}>
						<h4 className='aubrey-pro'>
							<FormattedMessage id='courseStructureTwo' />
						</h4>
					</div>
					<div className={style.colList}>
						<div id='structureTwo-first' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureTwo-first' />
							</h4>
						</div>
						<div id='structureTwo-second' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureTwo-second' />
							</h4>
						</div>
						<div id='structureTwo-third' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureTwo-third' />
							</h4>
						</div>
					</div>
				</div>
				<div className={style.list}>
					<div id='structureThree' className={style.colFirst}>
						<h4 className='aubrey-pro'>
							<FormattedMessage id='courseStructureThree' />
						</h4>
					</div>
					<div className={style.colList}>
						<div id='structureThree-first' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureThree-first' />
							</h4>
						</div>
						<div id='structureThree-second' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureThree-second' />
							</h4>
						</div>
						<div id='structureThree-third' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureThree-third' />
							</h4>
						</div>
						<div id='structureThree-fourth' className={style.stepWhite}>
							<h4>
								<FormattedMessage id='courseStructureThree-fourth' />
							</h4>
						</div>
					</div>
				</div>
			</div>
			<Xarrow
				start='structureOne'
				end='structureOne-first'
				zIndex={1}
				path='grid'
				startAnchor='right'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureOne'
				path='grid'
				zIndex={1}
				startAnchor='right'
				end='structureOne-second'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureOne'
				path='grid'
				zIndex={1}
				end='structureOne-third'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureOne'
				path='grid'
				zIndex={1}
				end='structureOne-fourth'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureOne-fourth'
				end='structureOne-fourth-1'
				zIndex={1}
				path='grid'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureOne-fourth'
				end='structureOne-fourth-2'
				zIndex={1}
				path='grid'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureTwo'
				path='grid'
				zIndex={1}
				end='structureTwo-first'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureTwo'
				path='grid'
				zIndex={1}
				end='structureTwo-second'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureTwo'
				end='structureTwo-third'
				zIndex={1}
				path='grid'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureThree'
				zIndex={1}
				path='grid'
				startAnchor='right'
				end='structureThree-first'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureThree'
				zIndex={1}
				path='grid'
				startAnchor='right'
				end='structureThree-second'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureThree'
				zIndex={1}
				path='grid'
				startAnchor='right'
				end='structureThree-third'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
			<Xarrow
				start='structureThree'
				zIndex={1}
				path='grid'
				startAnchor='right'
				end='structureThree-fourth'
				endAnchor='left'
				showHead={false}
				color='white'
			/>
		</div>
	);
};

export default StepItems;
